// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-divider {
  margin: 0;
  opacity: 1;
  border-color: #EDF2F7;
}
`, "",{"version":3,"sources":["webpack://./src/components/UiComponents/CustomDivider/CustomDivider.less"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,UAAA;EACA,qBAAA;AACF","sourcesContent":[".custom-divider {\n  margin: 0;\n  opacity: 1;\n  border-color: #EDF2F7;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
